export const journeyMilestones = [
  {
    year: "Age 58",
    title: "Rock Bottom",
    description: "240 lbs, pre-diabetic, couldn't climb a flight of stairs without losing breath. Doctor said I had 5 years before serious heart problems.",
    icon: "ri-heart-pulse-line",
    stat: "240 lbs"
  },
  {
    year: "Age 59",
    title: "The Decision",
    description: "Decided I wasn't going to accept decline as inevitable. Started with 10-minute walks. That was all I could do.",
    icon: "ri-footprint-line",
    stat: "10 min/day"
  },
  {
    year: "Age 60",
    title: "First Real Progress",
    description: "Lost 30 lbs. Started lifting weights for the first time in my life. Blood sugar normalized. Energy came back.",
    icon: "ri-scales-line",
    stat: "-30 lbs"
  },
  {
    year: "Age 61",
    title: "The Transformation",
    description: "Down to 185 lbs. Bench pressing my own bodyweight. Doctor took me off two medications. People stopped recognizing me.",
    icon: "ri-trophy-line",
    stat: "185 lbs"
  },
  {
    year: "Age 62",
    title: "Sharing It All",
    description: "Built the exact system that worked for me and packaged it for others. Because if I could do it at 58, you can do it now.",
    icon: "ri-share-circle-line",
    stat: "3 Products"
  }
];

export const healthStats = [
  { label: "Weight Lost", value: 55, suffix: " lbs", icon: "ri-scales-line" },
  { label: "Body Fat Reduced", value: 18, suffix: "%", icon: "ri-percent-line" },
  { label: "Medications Dropped", value: 3, suffix: "", icon: "ri-medicine-bottle-line" },
  { label: "Years of Transformation", value: 4, suffix: " yrs", icon: "ri-time-line" }
];

export const testimonialsMason = [
  {
    id: 1,
    quote: "I'm 64 and I've tried everything. Mason's blueprint is the first program that actually accounts for how our bodies work at this age. Down 22 lbs in 10 weeks.",
    name: "Gary Whitfield",
    detail: "Retired Teacher, 64",
    avatar: "https://public.readdy.ai/ai/img_res/4cbf9556413581a270242d190f240810.jpg"
  },
  {
    id: 2,
    quote: "The Clean Fuel Guide changed how I think about food entirely. I'm not dieting — I'm fueling. Lost 18 lbs and my energy is through the roof.",
    name: "Linda Marsh",
    detail: "Grandmother of 4, 61",
    avatar: "https://readdy.ai/api/search-image?query=Low%20quality%20selfie%20of%20older%20woman%20in%20her%20early%2060s%20with%20silver%20hair%20taken%20from%20below%20poor%20indoor%20lighting%20grainy%20photo%20authentic%20amateur%20candid%20shot%20real%20person&width=100&height=100&seq=tmason102&orientation=squarish"
  },
  {
    id: 3,
    quote: "Mason doesn't sugarcoat it. He tells you it's hard, shows you it's possible, and gives you the exact tools. The journal kept me accountable every single day.",
    name: "Dennis Kowalski",
    detail: "Construction Foreman, 59",
    avatar: "https://readdy.ai/api/search-image?query=Dimly%20lit%20selfie%20of%20rugged%20man%20in%20late%2050s%20with%20stubble%20taken%20in%20car%20or%20garage%20poor%20lighting%20grainy%20amateur%20photo%20authentic%20candid%20shot%20real%20person&width=100&height=100&seq=tmason103&orientation=squarish"
  },
  {
    id: 4,
    quote: "I was skeptical. A 62-year-old selling fitness? Then I saw his before and after. Bought all three products. Best money I've ever spent on my health.",
    name: "Tom Reeves",
    detail: "Business Owner, 63",
    avatar: "https://readdy.ai/api/search-image?query=Grainy%20selfie%20of%20confident%20man%20in%20early%2060s%20with%20gray%20temples%20taken%20indoors%20with%20poor%20lighting%20shadows%20on%20face%20authentic%20amateur%20photo%20real%20person%20candid%20shot&width=100&height=100&seq=tmason104&orientation=squarish"
  },
  {
    id: 5,
    quote: "My doctor is shocked. Off blood pressure meds after 8 months following Mason's program. This isn't just fitness — it's getting your life back.",
    name: "Ray Donovan",
    detail: "Veteran, 66",
    avatar: "https://readdy.ai/api/search-image?query=Low%20quality%20selfie%20of%20older%20veteran%20man%20in%20his%20mid%2060s%20short%20gray%20hair%20taken%20with%20poor%20lighting%20grainy%20photo%20authentic%20amateur%20candid%20shot%20real%20person&width=100&height=100&seq=tmason105&orientation=squarish"
  }
];